import { useState } from 'react'
import { Link } from 'react-router-dom'
import FeedbackModal from './FeedbackModal'

export default function Footer() {
  const [isFeedbackOpen, setIsFeedbackOpen] = useState(false)

  return (
    <footer className="bg-dark-950 border-t border-dark-800 py-12 px-4">
      <div className="max-w-6xl mx-auto grid md:grid-cols-4 gap-8">
        <div>
          <h3 className="text-lg font-bold mb-4 tracking-tight">
            GINGERBREAD<span className="text-ginger-500">!</span><span className="text-ginger-500">PRIVACY</span>
          </h3>
          <p className="text-dark-400 text-sm">
            Executive Privacy & Risk Intelligence. 25+ years of threat intelligence experience, automated.
            The $10K report, democratized.
          </p>
        </div>

        <div>
          <h4 className="font-semibold mb-4">Services</h4>
          <ul className="space-y-2 text-sm text-dark-400">
            <li><a href="#pricing" className="hover:text-dark-100">Free Snapshot</a></li>
            <li><a href="#pricing" className="hover:text-dark-100">Full Assessment</a></li>
            <li><a href="#pricing" className="hover:text-dark-100">Family Package</a></li>
            <li><a href="#" className="hover:text-dark-100">Inner Circle</a></li>
          </ul>
        </div>

        <div>
          <h4 className="font-semibold mb-4">Company</h4>
          <ul className="space-y-2 text-sm text-dark-400">
            <li><a href="#" className="hover:text-dark-100">About</a></li>
            <li><Link to="/privacy" className="hover:text-dark-100">Privacy Policy</Link></li>
            <li><Link to="/terms" className="hover:text-dark-100">Terms of Service</Link></li>
            <li><a href="mailto:services@monadnockcyber.ai" className="hover:text-dark-100">Contact</a></li>
          </ul>
        </div>

        <div>
          <h4 className="font-semibold mb-4">Contact</h4>
          <p className="text-dark-400 text-sm mb-2">
            Monadnock Cyber LLC<br />
            71 RT 101A Suite 11<br />
            Amherst, NH 03031
          </p>
          <a href="mailto:services@monadnockcyber.ai" className="text-ginger-500 text-sm hover:underline">
            services@monadnockcyber.ai
          </a>
        </div>
      </div>

      <div className="max-w-6xl mx-auto mt-12 pt-6 border-t border-dark-800 text-center text-dark-500 text-sm">
        <p>© 2025 Monadnock Cyber, LLC. All rights reserved.</p>
        <p className="mt-1">GINGERBREAD!PRIVACY is a registered trademark. Patent pending.</p>
        <p className="mt-2 text-dark-600 text-xs">PROPRIETARY AND CONFIDENTIAL</p>

        {/* AI-Assisted Feedback Button */}
        <div className="mt-6">
          <button
            onClick={() => setIsFeedbackOpen(true)}
            className="inline-flex items-center gap-2 px-4 py-2 bg-ginger-500/20 hover:bg-ginger-500/30 text-ginger-400 border border-ginger-500/40 rounded-lg transition-colors text-sm"
          >
            <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 10h.01M12 10h.01M16 10h.01M9 16H5a2 2 0 01-2-2V6a2 2 0 012-2h14a2 2 0 012 2v8a2 2 0 01-2 2h-5l-5 5v-5z" />
            </svg>
            Send Feedback
          </button>
        </div>
      </div>

      <FeedbackModal isOpen={isFeedbackOpen} onClose={() => setIsFeedbackOpen(false)} />
    </footer>
  )
}
